import type { LucideIcon } from 'lucide-react'
import { Brain, Wallet, Briefcase, HeartHandshake, Sun } from 'lucide-react'

export interface Lifespan {
  id: 'healthspan' | 'wealthspan' | 'workspan' | 'carespan' | 'thrivespan'
  name: string
  tagline: string
  description: string
  icon: LucideIcon
  color: string // distinct hue per span (Website Review V3 — "every circle a color")
  ink: string // same hue darkened to 4.6:1 on white, for text
}

// Copy per client Website Review (May 2026). LifeSpan is the comprehensive
// approach; these five spans are the domains it holds together.
export const lifespans: Lifespan[] = [
  {
    id: 'healthspan',
    name: 'HealthSpan',
    tagline:
      'Longevity is not just about living longer — it is about living better.',
    description:
      'Translating science and technology into accessible tools that enhance brain health and long-term productivity.',
    icon: Brain,
    color: '#2FA98C',
    ink: '#24836D',
  },
  {
    id: 'wealthspan',
    name: 'WealthSpan',
    tagline:
      'Economic security across a longer life requires new models and new partnerships.',
    description:
      'Strengthening financial security through literacy, innovative products, and secure digital platforms designed for all ages.',
    icon: Wallet,
    color: '#3A8DDD',
    ink: '#2377C9',
  },
  {
    id: 'workspan',
    name: 'WorkSpan',
    tagline:
      'The multigenerational workforce is not a challenge to manage — it is an asset to activate.',
    description:
      'Building intergenerational talent strategies, flexible work models, and upskilling pathways for a changing labor market and long-term civic and social engagement.',
    icon: Briefcase,
    color: '#5B6ED6',
    ink: '#596CD5',
  },
  {
    id: 'carespan',
    name: 'CareSpan',
    tagline:
      'Care infrastructure is the invisible backbone of the longevity economy.',
    description:
      'Enhancing caregiver capacity and system performance through education, technology, and redesigned service models.',
    icon: HeartHandshake,
    color: '#E8734A',
    ink: '#CC481A',
  },
  {
    id: 'thrivespan',
    name: 'ThriveSpan',
    tagline:
      'A longer life must be a meaningful life. Purpose is not a luxury — it is a longevity factor.',
    description:
      'Enabling meaningful, inclusive, accessible, and connected longer lives.',
    icon: Sun,
    color: '#E2A32B',
    ink: '#9A6C15',
  },
]
